<template>
  <main class="relative max-h-screen overflow-hidden font-roboto">
    <img src="../../assets/images/login_bg.jpg" alt="" class="w-full h-screen object-cover">
    <div class="absolute mobile:w-full largeDesktop:w-[700px] laptop:w-[550px] top-0 right-0">
      <div
        class="mobile:px-8 tablet:px-32 laptop:px-48 desktop:px-16 largeDesktop:px-28 h-screen flex flex-col items-center justify-center mobile:gap-3 tablet:gap-[20px] desktop:gap-[8px] largeDesktop:gap-[20px] bg-[#2459A8]">
        <!-- Logo -->
        <div class="flex justify-center">
          <img src="../../assets/images/MyHappy-Logo.png"
          class="w-[210px] tablet:w-[265px] object-cover mb-[20px] desktop:mb-[10px] largeDesktop:mb-[60px]" alt="fyxify Logo">
        </div>

        <div>
          <h2 class="text-[30px] laptop:text-[40px] font-roboto font-medium mb-[0px] tablet:mb-[20px] laptop:mb-[0px] text-center text-white">Verification</h2>
          <p class="mobile:text-lg tablet:text-[22px] text-center font-roboto text-white my-[10px] laptop:my-[15px] largeDesktop:my-[30px]">
            Please enter the 4-digit verification code sent to <br />
            <span class="font-normal">{{ savedData ? savedData.email : '' }}</span>
          </p>
        </div>

        <!-- Code Inputs -->
        <div class="flex justify-center gap-4 mb-[15px] tablet:mb-[25px] laptop:mb-[15px] largeDesktop:mb-4">
          <input v-for="(digit, index) in code" :key="index" v-model="code[index]" ref="inputs" @input="onInput(index)"
            @keydown.backspace="onBackspace(index)" maxlength="1" type="text" inputmode="numeric"
            class="w-[45px] h-[45px] text-center text-lg border rounded-[5px] focus:outline-none" />
        </div>
        <button :disabled="!isCodeComplete" @click="submitCode" :class="[
          'w-max py-[8px] tablet:py-[10px] px-[40px] tablet:px-[60px] text-base tablet:text-lg font-bold rounded-full border-solid border-[1px]',
          isCodeComplete
            ? 'CustomYellowBtn cursor-pointer focus:outline-none'
            : 'border-[#ffffff7a] !text-[#ffffff7a] cursor-not-allowed'
        ]">
          VERIFY
        </button>
        <div v-if="timer" class="mt -[15px] tablet:mt-[20px] desktop:mt-[10px] largeDesktop:mt-4 text-base tablet:text-lg font-normal text-white">
          <p class="text-center">
             Didn’t receive the code? You’ll be able to resend it in  
            <span>{{ timer == 0 ? '' : timer + ' seconds' }}</span>
          </p>
        </div>
        <div class="flex item-center justify-center gap-3 tablet:mt-[20px] laptop:mt-[10px]">
          <button
            class="CustomYellowBtn h-[43px] w-[125px] flex justify-center items-center font-roboto font-normal text-base tablet:text-lg rounded-[5px] border-[1px] border-customYellow-100 lg:text-customYellow-100 lg:!bg-transparent lg:!shadow-none focus:outline-none"
            @click="backClicked">
            Back
          </button>
          <button @click="resendCodeClicked" :disabled="timer > 0"
            class="CustomYellowBtn h-[43px] w-[125px] flex justify-center items-center font-roboto font-normal text-base tablet:text-lg rounded-[5px] border-[1px] disabled:border-[#ffffff7a] disabled:bg-transparent disabled:text-[#ffffff7a] disabled:cursor-not-allowed focus:outline-none disabled:!shadow-none">Re-send</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  data() {
    return {
      code: ["", "", "", ""],
      timer: 30,
      interval: null,
      savedData: JSON.parse(localStorage.getItem('registerFormData')) ?? null
    };
  },

  computed: {
    ...mapGetters(["resendCodeResponse", "userObject"]),
    isCodeComplete() {
      return this.code.every((digit) => digit !== "");
    },
  },

  watch: {
    resendCodeResponse: function () {
      this.timer = 30;
      this.startTimer();
    },

    userObject: function () {

      if (this.userObject != 'undefined') {
        localStorage.removeItem('registerFormData')
        localStorage.setItem('user', JSON.stringify(this.userObject))
        localStorage.setItem('isSilentLogin', false)
        this.$router.push({
          name: 'dashboard'
        })
      }

    },
  },

  mounted() {
    this.$refs.inputs[0].focus();
    this.startTimer();
  },
  methods: {
    ...mapActions(["resendCode", "verifyUser"]),

    onInput(index) {
      // Remove non-numeric characters
      this.code[index] = this.code[index].replace(/\D/g, '');

      // Ensure only one digit
      if (this.code[index].length > 1) {
        this.code[index] = this.code[index].slice(0, 1);
      }

      // Move to next input
      if (this.code[index] && index < this.code.length - 1) {
        this.$refs.inputs[index + 1].focus();
      }
    },
    onBackspace(index) {
      if (!this.code[index] && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    },
    submitCode() {
      if (this.savedData && this.savedData.email) {
        this.verifyUser({
          email: this.savedData.email,
          verification_code: this.code.join(""),
          device_type: 'web'
        })
      } else {
        toast.error("You are not allowed to perform this action.")
        this.$router.go(-1)
      }
    },
    resendCodeClicked() {
      if (this.savedData && this.savedData.email) {
        this.resendCode({
          email: this.savedData.email
        })
      } else {
        toast.error("You are not allowed to perform this action.")
        this.$router.go(-1)
      }

    },

    backClicked() {
      this.$router.go(-1)
    },
    startTimer() {
      if (this.interval) clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
  },
  unmounted() {
    if (this.interval) clearInterval(this.interval);
  },
};
</script>

<style scoped>
input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>